import {Component, ViewEncapsulation} from '@angular/core';
import {DataService} from '../Services/data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None

})

/**
 * App component is the base of the application and is always visible. The header is decided by the {@link DataService}
 */
export class AppComponent {
  dataService: DataService;
  constructor(private _dataService: DataService) {
    this.dataService = _dataService;
  }
}



// WEBPACK FOOTER //
// ./src/app/App/app.component.ts